import { render, staticRenderFns } from "./LeaveCanaelReason.vue?vue&type=template&id=56b62b5e&"
import script from "./LeaveCanaelReason.vue?vue&type=script&lang=js&"
export * from "./LeaveCanaelReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b62b5e')) {
      api.createRecord('56b62b5e', component.options)
    } else {
      api.reload('56b62b5e', component.options)
    }
    module.hot.accept("./LeaveCanaelReason.vue?vue&type=template&id=56b62b5e&", function () {
      api.rerender('56b62b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveCanaelReason/LeaveCanaelReason.vue"
export default component.exports